import React, { createContext, useState } from "react";

interface PendingDealersActionContextType {
  count: number;
  setCount: (count: number) => void;
}

export const PendingDealersActionContext =
  createContext<PendingDealersActionContextType>({
    count: 0,
    setCount: () => {},
  });

interface PendingDealersActionProviderProps {
  children: React.ReactNode;
}

export const PendingDealersActionProvider: React.FC<
  PendingDealersActionProviderProps
> = ({ children }) => {
  const [count, setCount] = useState(0);

  const value = {
    count,
    setCount,
  };
  return (
    <PendingDealersActionContext.Provider value={value}>
      {children}
    </PendingDealersActionContext.Provider>
  );
};
